import { render, staticRenderFns } from "./ProyeccionMaquinas.vue?vue&type=template&id=0b7705bb&scoped=true&"
import script from "./ProyeccionMaquinas.vue?vue&type=script&lang=js&"
export * from "./ProyeccionMaquinas.vue?vue&type=script&lang=js&"
import style0 from "./ProyeccionMaquinas.vue?vue&type=style&index=0&id=0b7705bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7705bb",
  null
  
)

export default component.exports